import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { components } from 'react-select';
import { capitalize } from 'lodash';

import { useTranslation } from 'app/lang';
import { ComponentsConfig, Control, MenuList, Option } from 'app/widgets/Dropdown/Single';

import type { AccountSelectOptionProps } from './index';

import dictionary from './AccountSelect.dictionary.json';

import styles from './AccountSelect.module.scss';

// ---

function DropdownComponents(
  disabledPledgeStakeTitle?: string,
  menuListBottom?: number | null,
  setMenuListBottom?: Dispatch<SetStateAction<number | null>>,
  menuPlacement?: string,
): ComponentsConfig<AccountSelectOptionProps> {
  const { t } = useTranslation();
  return useMemo(() => ({
    MenuList: (props) => (
      <MenuList {...props}
                setMenuListBottom={setMenuListBottom}>
        {props.children}
      </MenuList>
    ),
    MenuPortal: (props) => (
      <components.MenuPortal {...props}>
        <div className={styles.portal}>
          {props.children}
        </div>
      </components.MenuPortal>
    ),
    Option: (props) => {
      return (
        <Option {...props}
                customInnerProps={{
                  ['data-ga-event']: 'cart-bidSourceSelect',
                }}>
          <div title={capitalize(disabledPledgeStakeTitle)}>
            {props.children}
          </div>
        </Option>
      );
    },
    Control: (props) => (
      <Control {...props}
               customInnerProps={{ title: t(dictionary.controlTitle) }}>
        {props.children}
      </Control>
    ),
  }), [
    disabledPledgeStakeTitle,
    setMenuListBottom,
    menuPlacement,
    menuListBottom,
  ]);
}

export default DropdownComponents;
